(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review-videos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
   let lazyVideos = document.querySelectorAll("video.lazyVideo");

   if ("IntersectionObserver" in window) {
     let lazyVideoObserver = new IntersectionObserver(function(entries) {
       entries.forEach(function(video) {
         if (video.isIntersecting) {
           for (let source in video.target.children) {
             let videoSource = video.target.children[source];
             if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
               videoSource.src = videoSource.dataset.src;
             }
           }

           video.target.load();
           video.target.classList.remove("lazyVideo");
           lazyVideoObserver.unobserve(video.target);
         }
       });
     });

     lazyVideos.forEach(function(lazyVideo) {
       lazyVideoObserver.observe(lazyVideo);
     });
   }
  });

  } catch(e) { console.error(e); }
})();
})();
